export * from '@/components/Event/EventEditTagGroup';
export { default } from '@/components/Event/EventEditTagGroup';
